var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErgoLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 68.4 20",
    style: {
      enableBackground: "new 0 0 68.4 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BF1528;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59,0c-4.8,0-9.6,3.4-9.6,10c0,6.2,4,10,9.4,10c5.7,0,9.6-4.2,9.6-10C68.4,3.2,63.6,0,59,0z M58.9,16 c-2.8,0-4.8-2.3-4.8-6c0-3.3,1.7-6,4.8-6c3.5,0,4.8,3.2,4.8,6C63.7,12.8,62.3,16,58.9,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.2,8.4l0,3.8h3.3v3.4c-0.3,0.2-1.1,0.4-2.3,0.4c-3.2,0-5.1-2.4-5.1-6c0-3.4,1.4-5.8,5.5-5.8 c1.7,0,3.1,0.3,4.3,0.8l1.6-3.8C45.8,0.5,44,0,41.2,0c-5.6,0-10,4-10,10.1c0,5.4,3.2,9.9,9.6,9.9c3.3,0,5.7-1,6.8-1.8V8.4 L40.2,8.4L40.2,8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.5,12.2L26.5,12.2c1-0.7,1.9-1.6,2.4-2.4c0.6-1,0.9-2.1,0.9-3.3c0-0.9-0.2-1.7-0.5-2.5 c-0.3-0.8-0.8-1.5-1.5-2.1c-0.7-0.6-1.5-1-2.6-1.4C24.3,0.2,23,0,21.5,0c-1.1,0-2.2,0.1-3.1,0.1c-1,0.1-1.7,0.2-2.6,0.3v19.2h4.5 v-6.4c0.6,0,1,0,1.6,0c0,0,0.6,0.2,1.3,1.2c0.9,1.1,1.9,2.9,2.6,5.2h5.3C29.9,16.3,28.7,13.1,26.5,12.2z M24.4,8.9 c-0.6,0.5-1.6,0.8-2.7,0.8c-0.5,0-1.1,0-1.4-0.1V4.1c0.2,0,0.9-0.1,1.1-0.1c0.3,0,0.7,0,0.8,0c1,0,1.8,0.2,2.3,0.7 c0.6,0.4,0.9,1.1,0.9,1.9C25.4,7.6,25,8.4,24.4,8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.2,15.6c-1,0-1.8-0.6-1.8-1.9v-2.1h7.4l0-3.9H4.5V4.4h8.7V0.3H0v14.8c0,3,1.2,4.6,4.6,4.6h9l0-4.1 C13.5,15.6,8.3,15.6,6.2,15.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErgoLogo);
export default __webpack_public_path__ + "static/media/ergo_logo.9696f2bae160934507389ca62828dde2.svg";
export { ForwardRef as ReactComponent };